import { DateTime } from 'luxon'
import i18n from 'i18next'

const getLocale = () => i18n.language || 'it'

export const formattedTs = (ts: string) => {
  return DateTime.fromISO(ts).toFormat('EEE, MMM dd, HH:mm', { locale: getLocale() })
}

export const formatISODate = (date: string) => {
  const locale = getLocale()
  const dt = DateTime.fromISO(date)
  const now = DateTime.now()
  const time = dt.toFormat('HH:mm')

  if (dt.hasSame(now, 'day')) {
    return `${dt.toRelativeCalendar({ locale })}, ${time}`
  }

  if (dt.hasSame(now.minus({ days: 1 }), 'day')) {
    return `${dt.toRelativeCalendar({ locale })}, ${time}`
  }

  return `${dt.toFormat('dd MMM yyyy', { locale })}, ${time}`
}
